module.exports = __webpack_public_path__ + "img/settings_edit_beacon_location_move_tag.f2b39979.png";